const MESSAGES: [string, string][] = [
  ["form_password_pwned", "这个密码出现在泄露名单里，请换一个。"],
  ["password_compromised", "这个密码出现在泄露名单里，请换一个。"],
  ["password_pwned", "这个密码出现在泄露名单里，请换一个。"],
  ["form_password_length_too_short", "密码至少 15 位。"],
  ["password_length_too_short", "密码至少 15 位。"],
  ["form_password_not_strong_enough", "密码不够安全。至少 15 位，且不能是已泄露的密码。"],
  ["form_password_validation_failed", "密码不够安全。至少 15 位，且不能是已泄露的密码。"],
  ["form_password_or_identifier_incorrect", "邮箱或密码不对。"],
  ["form_password_incorrect", "邮箱或密码不对。"],
  ["strategy_for_user_invalid", "这个账号还没有密码。请用「忘记密码」，用邮箱验证码设一个。"],
  ["form_identifier_exists", "该邮箱已注册，请直接登录或忘记密码"],
  ["form_identifier_not_found", "找不到这个邮箱。"],
  ["form_code_incorrect", "验证码不对。"],
  ["form_code_expired", "验证码过期了，请重新发送。"],
  ["verification_expired", "验证码过期了，请重新发送。"],
  ["too_many_requests", "尝试太频繁，请稍后再试。"],
  ["form_password_size_in_bytes_exceeded", "密码太长了。"],
];

type ClerkLike = {
  code?: string;
  message?: string;
  longMessage?: string;
  errors?: { code?: string; message?: string; longMessage?: string }[];
};

export function clerkCode(cause: unknown): string {
  const error = cause as ClerkLike;
  return error.errors?.[0]?.code || error.code || "";
}

export function clerkMessage(cause: unknown, fallback = "没有完成，请再试一次。"): string {
  const code = clerkCode(cause);
  const match = MESSAGES.find(([key]) => code === key || code.includes(key));
  return match?.[1] ?? fallback;
}

export function clerkFailure(cause: unknown, fallback: string): { summary: string; detail: string } {
  const error = cause as ClerkLike;
  const first = error.errors?.[0];
  const code = first?.code || error.code || "";
  const longMessage = first?.longMessage || first?.message || error.longMessage || error.message || "";
  return {
    summary: clerkMessage(cause, fallback),
    detail: [code, longMessage].filter(Boolean).join(" — "),
  };
}
